import React, { useState, useEffect } from 'react'
import injectSheet from 'react-jss'
import FormInput from 'pobble-components/dist/form-elements/form-input'
import Button from 'pobble-components/dist/button'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSearch } from '@fortawesome/pro-solid-svg-icons/faSearch'
import { faLongArrowAltDown } from '@fortawesome/pro-solid-svg-icons/faLongArrowAltDown'
import { faLongArrowAltUp } from '@fortawesome/pro-solid-svg-icons/faLongArrowAltUp'
import FormSelect from 'pobble-components/dist/form-elements/form-select'
import { useMe } from 'pobble-components/dist/pobble-user'
import classNames from 'classnames'
import { useDispatch, useSelector } from 'react-redux'
import { getFilters } from '../../../../../../stores/my-presentations/my-presentations.selectors'
import { fetchMyPresentations } from '../../../../../../stores/my-presentations/my-presentations.actions'

const styles = ({ COLORS }) => ({
  container: {
    marginBottom: '20px',
    paddingRight: '10px',
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    '@media (min-width: 768px)': {
      flexDirection: 'row'
    }
  },
  searchHolder: {
    width: '100%'
  },
  filtersHolder: {
    marginTop: '16px',
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    '@media (min-width: 768px)': {
      width: 'auto',
      margin: '0 0 0 16px',
      '&:before': {
        content: '""',
        width: '1px',
        height: '20px',
        background: '#ececec',
        marginRight: '16px'
      }
    },
    '& label': {
      marginBottom: '4px',
      whiteSpace: 'nowrap',
      display: 'flex',
      '@media (min-width: 768px)': {
        margin: '0 8px 0 0'
      }
    },
    '& > *': {
      flex: '1',
      '&:first-child': {
        marginRight: '16px'
      },
      '@media (min-width: 768px)': {
        display: 'flex',
        alignItems: 'center'
      }
    }
  },
  sortHolder: {
    display: 'flex',
    '& > *:first-child': {
      flex: '1',
      minWidth: '106px'
    }
  },
  sortDirection: {
    marginLeft: '4px',
    borderColor: '#ddd !important',
    color: `${COLORS.TEXT.MID_GREY.NORMAL} !important`,
    background: '#fff !important'
  },
  search: {
    display: 'flex',
    '& input': {
      borderRadius: '4px 0 0 4px',
      borderRight: 'none'
    }
  },
  filterSelect: {
    minWidth: '100px'
  },
  searchSpinner: {
    fontSize: '18px',
    color: '#fff'
  },
  searchButton: {
    borderRadius: '0 4px 4px 0',
    height: '40px',
    width: '40px',
    display: 'flex',
    justifyContent: 'center',
    padding: '0',
    flexShrink: '0'
  }
})

const Controls = ({ classes }) => {
  const [searchValue, setSearchValue] = useState('')
  const [filter, setFilter] = useState('all')

  const filters = useSelector(getFilters)
  const dispatch = useDispatch()
  const fetchPresentations = params => dispatch(fetchMyPresentations(params))
  const orderDirection = !filters.order ? 'desc' : filters.order
  const orderBy = !filters.order_by ? 'change' : filters.order_by

  const { me } = useMe()
  const canUseLessons = !!me.account.policy.can_use_lessons

  useEffect(
    () => {
      if (filters) {
        setSearchValue(filters.search_string || '')
        setFilter(filters.scope)
      }
    },
    [filters]
  )
  return (
    <div className={classes.container}>
      <div className={classes.searchHolder}>
        <form
          className={classNames(classes.search, 'metrics__my_lessons_search')}
          onSubmit={e => {
            e.preventDefault()
            fetchPresentations({
              scope: filter,
              page: 0,
              limit: 10,
              search_string: searchValue,
              initiator: 'FILTERS'
            })
          }}>
          <FormInput
            onClear={() => {
              fetchPresentations({
                ...filters,
                search_string: '',
                initiator: 'FILTERS'
              })
            }}
            clearable
            value={searchValue}
            onChange={e => setSearchValue(e.target.value)}
            placeholder="Search"
          />
          <Button type="submit" className={classes.searchButton}>
            <FontAwesomeIcon icon={faSearch} />
          </Button>
        </form>
      </div>
      <div className={classes.filtersHolder}>
        <div>
          <label>Filter by</label>
          <FormSelect
            className={classes.filterSelect}
            value={filter}
            onChange={e => {
              const filter = e.target.value
              setFilter(e.target.value)
              fetchPresentations({
                scope: filter,
                page: 0,
                limit: 10,
                search_string: searchValue,
                initiator: 'FILTERS',
                order: orderDirection
              })
            }}>
            <option value="all">All</option>
            {canUseLessons && <option value="delivered">Delivered</option>}
            <option value="public">Public</option>
            <option value="private">Private</option>
          </FormSelect>
        </div>
        <div>
          <label>Sort by</label>
          <div className={classes.sortHolder}>
            <FormSelect
              value={orderBy}
              onChange={e => {
                fetchPresentations({
                  ...filters,
                  scope: filter,
                  page: 0,
                  limit: 10,
                  initiator: 'SORT',
                  order_by: e.target.value
                })
              }}>
              <option value="change">Updated</option>
              <option value="creation">Created</option>
            </FormSelect>
            <Button
              action={() => {
                fetchPresentations({
                  ...filters,
                  page: 0,
                  limit: 10,
                  initiator: 'SORT',
                  order: orderDirection === 'desc' ? 'asc' : 'desc'
                })
              }}
              tall
              secondary
              className={classes.sortDirection}>
              <FontAwesomeIcon
                icon={
                  orderDirection === 'desc'
                    ? faLongArrowAltDown
                    : faLongArrowAltUp
                }
              />
            </Button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default injectSheet(styles)(Controls)
